export const timerStates = {
  inactive: 'inactive',
  active: 'active',
  paused: 'paused',
};
